import { Manufacturer } from '../../services/api/domains/manufacturers/types';

/**
 * The 7 real per-source linkage flags (Requirement 7 — CEP has no column,
 * see fields.ts's header comment) and whether each source's manufacturer-
 * level linking is actually built yet. Mirrors
 * `api/sql/manufacturerLinkSources.js`'s `connected` flags — kept as a
 * small duplicated constant rather than an API round-trip. Keep in sync if
 * a source's `connected` state changes.
 *
 * Single source of truth for both `StatusSection.tsx` (the flag chips) and
 * `exportAdapter.ts` (`UNCONNECTED_LINKAGE_FIELD_KEYS`, derived below) — a
 * new source added on the backend used to require updating this set in two
 * places by hand.
 */
export const LINKAGE_FLAGS: {
  key: keyof Manufacturer;
  label: string;
  connected: boolean;
}[] = [
  { key: 'is_decrs_linked', label: 'DECRS', connected: true },
  { key: 'is_gleif_linked', label: 'GLEIF', connected: true },
  { key: 'is_sap_aml_linked', label: 'SAP AML', connected: true },
  { key: 'is_salesforce_linked', label: 'Salesforce', connected: false },
  { key: 'is_usdmf_linked', label: 'USDMF', connected: false },
  { key: 'is_orangebook_linked', label: 'Orange Book', connected: false },
  { key: 'is_ndc_linked', label: 'NDC', connected: false },
];

/**
 * Linkage-flag field keys whose underlying source has no real matcher yet.
 * For these, `false` doesn't mean "checked and not linked" — it means "not
 * yet checked at all" (Sub-task 9.3 AC: "Source-registry connected state
 * included so unconnected flags are not exported as bare false").
 */
export const UNCONNECTED_LINKAGE_FIELD_KEYS = new Set<string>(
  LINKAGE_FLAGS.filter(flag => !flag.connected).map(flag => flag.key)
);
